function hashString(name: string) {
    let hash = 0;

    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }

    return Math.abs(hash);
}

export function getAvatarColor(name: string) {
    const colors = [
        "#3B82F6",
        "#10B981",
        "#F59E0B",
        "#EF4444",
        "#8B5CF6",
        "#14B8A6",
        "#F97316",
        "#6366F1",
    ];

    return colors[hashString(name) % colors.length];
}

/** Light pastel background + readable dark text, for tag chips/badges. */
export function getTagColor(name: string) {
    const colors = [
        { bg: "#DBEAFE", text: "#1D4ED8" },
        { bg: "#D1FAE5", text: "#047857" },
        { bg: "#FEF3C7", text: "#B45309" },
        { bg: "#FEE2E2", text: "#B91C1C" },
        { bg: "#EDE9FE", text: "#6D28D9" },
        { bg: "#CCFBF1", text: "#0F766E" },
        { bg: "#FFEDD5", text: "#C2410C" },
        { bg: "#E0E7FF", text: "#4338CA" },
    ];

    return colors[hashString(name) % colors.length];
}

/** CSS custom properties for a tag chip — spread into a `style` prop. */
export function getTagStyle(name: string): Record<string, string> {
    const { bg, text } = getTagColor(name);
    return { "--av-bg": bg, "--av-text": text };
}
